import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/** Deep links redirect into the storefront, which opens the booking modal. */
export function BookingDetailPage() {
  const { storeUrl, slotId } = useParams<{
    storeUrl: string;
    slotId: string;
  }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!storeUrl) return;
    navigate(`/${storeUrl}`, {
      replace: true,
      state: slotId ? { bookingSlotId: slotId } : undefined,
    });
  }, [navigate, storeUrl, slotId]);

  return null;
}
